import React from 'react';

import image0 from "./images/iot_motion.png";
import image1 from "./images/bollard.png";
import image2 from "./images/reviz.png";
import image3 from "./images/phys_io_2.png";
import image4 from "./images/processing_to_unity.png";
import image5 from "./images/react_parcel.png";

import image6 from "./images/sketch3d.png";

import image7 from "./images/less_homeless.png";
import image_react_components from "./images/react_container_3d.png";
import workshop from "./images/3d_visualizations.png";
import talk0 from "./images/talk0.png";

let curX=0; 

var x = (top=true, x=1.01)=>{
    if(top){
        var r = curX;
        curX += (x + Math.random()*0.11);
        return r;
    }
    else{
        var r =  curX + Math.random()*0.7;
        curX += Math.random()*0.5;
        return r;
    }
};



const projects = [{
            title: "IoT motion analysis",
            image: image0,
            size: 1.25,
            text: "indoors motion analysis using PIR (passive infrared) sensors, data visualization infrastructure and terMITes technology",
            year: "2017",
            type: "hardware",
            grid: {
                x: x(),
                y: 0.8
            },
            link: {
                external: false,
                url: "http://lucascassiano.github.io",
                projectID: "iot_motion"
            },
            imageBig: image0,
            details: ( <div> 
                This experiment was deployed in the MIT's E14 (media lab) building., with the goal to collect data from facility occupancy. 
One of the first steps in this project was to design and fabricate (using digital fabrication techniques, e.g. 3d printing and laser cutting) few dozens of sensors cases.  Using terMITes devices (powered by ESP8266 chipsets), coupled with PIR motion sensors the devices reported whenever a person walked in front of it. Using MQTT communication protocol over a static wifi AP. 
The data collected by the IoT devices was later visualized in a Progressive Web App using React, three.js, and D3.
                </div>)
            },
            {
                title: "Bollard.io",
                image: image1,
                size: 1,
                text: "Concept of Internet of Things device for mobility tracking",
                year: "2016",
                type: "design | concept",
                grid: {
                    x: x(false),
                    y: -1.4
                }
            },
            {
                title: "ReViz3D",
                image: image2,
                size: 1.2,
                text: "Toolkit to develop 3D Data visualization of rapid prototyped devices with support for React.js and WebGL components",
                year: "2018",
                type: "Software | WebGL",
                grid: {
                    x: x(),
                    y: 1
                }
            },

            {
                title: "3D Data Visualization",
                image: workshop,
                size: 1.2,
                text: "Workshop and Ebook (still only in portuguese) about 3D Data visualization on the web",
                year: "2017",
                type: "worshop | ebook",
                grid: {
                    x: x(false),
                    y: -1.1
                }
            },
            
            {
                title: "Talk: Innovation at MIT",
                image: talk0,
                size: 0.8,
                text: "Talk about technology innovation development at MIT, compared to Brazil",
                year: "2017",
                type: "media",
                grid: {
                    x: x(),
                    y: 1.1
                }
            },

            {
                title: "phys.io",
                image: image3,
                size: 1,
                text: "Wearable Hand Tracking Device",
                year: "2016",
                type: "Hardware | Software | Design",
                grid: {
                    x: x(false),
                    y: -1
                },
                link: {
                    external: true,
                    url: "https://github.com/lucascassiano/Processing-to-Unity"
                },
                details: "This paper describes the development of a human computer interface focused in detect hand movements and gestures and apply this data into a 3D environment, all this running based on an Android mobile device."
                
            },
            
            {
                title: "React+Parcel+Electron",
                image: image5,
                size: 0.85,
                text: "Desktop Web App generator ",
                year: "2018",
                type: "Software | JavaScript",
                grid: {
                    x: x(),
                    y: 1
                },
                details:"boilerplate for desktop web apps with React (UI) + Babel(Compiler) + Parcel(Bundler) + Electron (Packager)",
                link:{
                    external: true,
                    url:"https://github.com/lucascassiano/react-electron-parcel"
                }

            },

            {
                title: "React 3D Components",
                image: image_react_components,
                size: 0.85,
                text: "React-cubeview and React-container-3d are (as the name suggests) React components that wrap three.js renderers and provides a higher abstraction layer 3D controllers",
                year: "2017",
                type: "Software | JavaScript",
                grid: {
                    x: x(false),
                    y: -1.05
                },
                details:"boilerplate for desktop web apps with React (UI) + Babel(Compiler) + Parcel(Bundler) + Electron (Packager)",
                link:{
                    external: true,
                    url:"https://github.com/lucascassiano/react-electron-parcel"
                }

            },

            {
                title: "Sketch 3D",
                image: image6,
                size: 1.1,
                text: "Sketch 3D is a native Android App developed entirely by me, in 2014, as a study project. The app was made using Java, all based in Open GL ES 2.0, using Android Studio as IDE",
                year: "2014 | 2015 - 50k+ downloads",
                type: "Software | Java | Android",
                grid: {
                    x: x(),
                    y: 1.2
                },

            },

            {
                title: "Processing To Unity",
                image: image4,
                size: 0.8,
                text: "Send Processing Screen Image to Unity",
                year: "2016",
                type: "Software | Java | C#",
                grid: {
                    x:x(),
                    y: 1.2
                },
                link: {
                    external: true,
                    url: "https://github.com/lucascassiano/Processing-to-Unity"
                },
                details: "Render Processing Screens as an Unity Texture2D (compatible with Windows, OSX and Linux)",
            },

            {
                title: "LessHomeless",
                image: image7,
                size: 0.8,
                text: "Open Source population data collection Mobile/Web app",
                year: "2014",
                type: "Software | JavaScript | PHP",
                grid: {
                    x: x(false),
                    y: -1
                },

            },

        ];

        export default projects;


// WEBPACK FOOTER //
// ./src/content/index.js